import clsx from 'clsx';
import styles from './Skeleton.module.scss';

interface SkeletonProps {
  width?: string;
  height?: string;
  aspectRatio?: string;
  radius?: string;
  className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  width,
  height,
  aspectRatio,
  radius,
  className,
}) => (
  <span
    aria-hidden="true"
    role="presentation"
    className={clsx(styles.skeleton, className)}
    style={
      {
        '--_skeleton-width': width,
        '--_skeleton-height': height,
        '--_skeleton-aspect-ratio': aspectRatio,
        '--_skeleton-radius': radius,
      } as React.CSSProperties
    }
  />
);

interface SkeletonCircleProps {
  width?: string;
  className?: string;
}

export const SkeletonCircle: React.FC<SkeletonCircleProps> = ({ width, className }) => (
  <span
    aria-hidden="true"
    role="presentation"
    className={clsx(styles.skeletonCircle, className)}
    style={
      {
        '--_skeleton-width': width,
      } as React.CSSProperties
    }
  />
);
